import {
  Directive,
  ElementRef,
  Renderer2,
  Input,
  AfterViewInit,
} from '@angular/core';

@Directive({
  selector: '[smlShowHideToggle]',
})
export class ShowHideToggleDirective implements AfterViewInit {
  @Input() collapsedHeight = '120px'; // Default collapsed height
  isOverflowing = false;
  isExpanded = false;
  showButton = false;
  contentDiv!: HTMLElement;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    this.contentDiv = this.el.nativeElement;
    this.checkOverflow();
    this.setButtonVisibility();
  }

  checkOverflow() {
    const element = this.contentDiv;
    this.isOverflowing = element.scrollHeight > element.clientHeight;
    this.setButtonVisibility();
  }

  setButtonVisibility() {
    this.showButton = this.isOverflowing;
  }

  toggleShowMore() {
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded) {
      this.renderer.setStyle(this.contentDiv, 'max-height', 'none'); // Show all content
    } else {
      this.renderer.setStyle(
        this.contentDiv,
        'max-height',
        this.collapsedHeight,
      ); // Limit content
    }
  }

  get showButtonContent(): string {
    return this.isExpanded ? 'Show less' : 'Show more';
  }
}
